export const DEFAULT_PAGE_SIZES = [8, 50, 100];

export const showOnText = 'Показывать по';
